import React, { useState, useEffect } from "react";

import UIButton from "components/UI/Button/Button";
import UIInput from "components/UI/FormInput/FormInput";
import UILoader from "components/UI/Loader/Loader";
import * as ConfigTypes from 'config/ConfigTypes';
import { confirmInputMsg } from 'helpers/AppHelper';
import "./LoginForm.scss";

const BtnLoader = ({ fm }) => {
    return (
        <div className="loginform-btn-group">
            <span>
                {fm({ id: "data.auth.login" })}
            </span>
            <div className="loginform-loading"><UILoader /></div>
        </div>
    )
}

const LoginForm = (props) => {
    const { formatMessage, onSubmitClick, onRegisterClick, errors, loading, loginErr, reqForgotPw } = props;
    const [userInputs, setUserInputs] = useState({});
    let data = ConfigTypes.LOGIN_ITEMS;
    // if (authForm == ConfigTypes.REGISTER) data = ConfigTypes.REGISTER_ITEMS;

    const handleOkClick = () => {
        onSubmitClick(userInputs);
    }

    const handleHereClick = () => {
        // if (authForm === ConfigTypes.LOGIN) onRegisterClick();
        // else if (authForm === ConfigTypes.REGISTER) onLoginClick();
        onRegisterClick();
    }

    const handleChange = (e, name) => {
        setUserInputs((prev) => {
            return ({ ...prev, [name]: e.target.value });
        });
    }


    const onForgetPw = () => {
        confirmInputMsg({
            titleIntl: "auth.forgetPw", textInputIntl: "auth.forget.email",
            emptyIntl: "auth.youremail",
            confirmBtnClass: 'loginform-forgetconfirm', cancelBtnClass: '',
            formatMessage, cb: (email) => {
                if (email) {
                    reqForgotPw({ email });
                }
            }
        });
    }


    return (
        <div className="LoginForm">
            <h1>
                {formatMessage({ id: "data.auth.login" })}
            </h1>
            <>
                <p className="loginform-logintext">
                    {formatMessage({ id: "data.auth.logintext" })}
                </p>
                {data && data.map((item, idx) => (
                    <UIInput name={item.name} key={`signin${idx}`} value={userInputs[`${item.name}`]} type={item.type}
                        onChange={(e) => handleChange(e, item.name)} error={errors[`${item.name}`]} required={item.required}
                        placeholder={formatMessage({ id: item.intl })} hiddenStar={item.hiddenStar} />
                ))}
                <UIButton textOnly onClick={handleOkClick} className="loginform-button">
                    {loading ? <BtnLoader fm={formatMessage} /> : formatMessage({ id: "data.auth.login" })}
                </UIButton>
            </>
            <>
                {(loginErr) && (<p className="loginform-loginerror">
                    {formatMessage({ id: "data.auth.loginerror" })}
                </p>)}
                <p className="loginform-toggleaction" onClick={onForgetPw}>
                    {formatMessage({ id: "data.auth.forgetpassword" })}
                </p>
                <p className="loginform-actionhere" onClick={handleHereClick}>
                    {formatMessage({ id: "data.auth.registerhere" })}
                </p>
            </>
        </div>
    )
}

export default LoginForm;